import { palette } from '@livable/saas-react-components';
const MuiSkeleton = {
  styleOverrides: {
    root: {
      backgroundColor: palette.shades[300]
    },
    text: {
      transform: 'scale(1, 1)'
    }
  }
};
export default MuiSkeleton;